import {handleActions} from 'redux-actions';
import Loading from '../../../components/Loading';
import * as type from './actionTypes';
const initState = {
    data:{},
    carTypes:null,
    carSeries:null,
    changeLicensePlateNoCode:''
}
const actions = {}
/*ocr识别*/
actions[type.OCR_IDENTIFYSTART] = (state, action) => {
    return{
        ...state,
        type:action.payload.type
    }
}
actions[type.OCR_IDENTIFYSUCCESS] = (state, action) => {
    return{
        ...state,
        data:action.payload.data.result,
        type:action.payload.type
    }
}
actions[type.OCR_IDENTIFYERROR] = (state, action) => {
    return{
        ...state,
        data:{},
        type:action.payload.type
    }
}
/*车型选择*/
/*获取所有车辆厂商*/
actions[type.GET_CARBRANDSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state,
        carTypes:null,
        type:action.payload.type
    }
}
actions[type.GET_CARBRANDSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carTypes:action.payload.result,
        type:'carBrand'
    }
}
actions[type.GET_CARBRANDERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carTypes:null,
        type:action.payload.type
    }
}
/*根据品牌厂商获取车系*/
actions[type.GET_CARSERIESSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state,
        carSeries:null,
        type:action.payload.type
    }
}
actions[type.GET_CARSERIESSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carSeries:action.payload.result,
        type:'carSeries'
    }
}
actions[type.GET_CARSERIESERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carSeries:null,
        type:action.payload.type
    }
}
/*根据车系获取车型信息*/
actions[type.GET_CARINFOSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state,
        carInfo:null,
        type:action.payload.type
    }
}
actions[type.GET_CARINFOSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carInfo:action.payload.result,
        type:'carInfo'
    }
}
actions[type.GET_CARINFOERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carInfo:null,
        type:action.payload.type
    }
}
/*根据品牌获取厂商列表*/
actions[type.GET_CARVENDORSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state,
        carVendor:null,
        type:action.payload.type
    }
}
actions[type.GET_CARVENDORSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carVendor:action.payload.result,
        type:'carVendor'
    }
}
actions[type.GET_CARVENDORERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carVendor:null,
        type:action.payload.type
    }
}
/*根据排量或变速器获取车型信息列表*/
actions[type.FILTERVEHICLESTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state
    }
}
actions[type.FILTERVEHICLESUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        carInfo:action.payload.result,
        type:'carInfo'
    }
}
actions[type.FILTERVEHICLEERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state
    }
}
/*搜索获取车辆信息列表*/
actions[type.SEARCHCARINFOSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state
    }
}
actions[type.SEARCHCARINFOSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        searchInfo:action.payload.result,
        type:'searchInfo'
    }
}
actions[type.SEARCHCARINFOERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state
    }
}
/*根据Vin码获取车型信息列表*/
actions[type.GET_CARINFOBYVINSTART] = (state, action) => {
    console.log('start',action);
    return{
        ...state
    }
}
actions[type.GET_CARINFOBYVINSUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        code:action.payload.code,
        carInfoByVin:action.payload.result,
        type:'byVin'
    }
}
actions[type.GET_CARINFOBYVINERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        code:action.payload.code,
        carInfoByVin:action.payload.result,
        type:'byVin'
    }
}
/*修改车牌*/
actions[type.CHANGE_LICENSEPLATENOSUCCESS] = (state, action) => {
    console.log(action);
    return{
        ...state,
        changeLicensePlateNoCode:action.payload.code,
        type:'changeLicensePlateNoSuccess'
    }
}
actions[type.CHANGE_LICENSEPLATENOERROR] = (state, action) => {
    return{
        ...state,
        changeLicesePlateNoCode:action.payload.code,
        type:'changeLicesePlateNoError'
    }
}
/*立即报价*/
actions[type.OFFER_PRICESTART] = (state, action) => {
    return{
        ...state 
    }
}
// 接口成功
actions[type.OFFER_PRICESUCCESS] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        offerInfo:action.payload,
        type:'offerInfo'
    }
}
// 接口失败
actions[type.OFFER_PRICEERROR] = (state, action) => {
    Loading.hide();
    return{
        ...state,
        type:'pfferPriceError'
    }
}
export const insuranceInfoReducer = handleActions(actions, initState)
